import { savePDF } from "@progress/kendo-react-pdf";

export const TELEMETRY_PRINT_BODY_CLASS = "field-app-telemetry-printing";
export const TELEMETRY_EXPORT_AREA_CLASS = "field-app-telemetry-schedule--compact";

function sanitizeFilePart(value) {
  return String(value || "telemetria")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 80);
}

export function buildTelemetryScheduleFileName({ operatorLabel, periodLabel }) {
  const operator = sanitizeFilePart(operatorLabel || "operador");
  const period = sanitizeFilePart(periodLabel || "periodo");
  return `telemetria_${operator}_${period}.pdf`;
}

export function printTelemetrySchedule() {
  const cleanup = () => {
    document.body.classList.remove(TELEMETRY_PRINT_BODY_CLASS);
    window.removeEventListener("afterprint", cleanup);
  };

  window.addEventListener("afterprint", cleanup);
  document.body.classList.add(TELEMETRY_PRINT_BODY_CLASS);
  window.print();
}

export async function exportTelemetrySchedulePdf(element, fileName) {
  if (!element) return;

  const rowCount = element.querySelectorAll(
    ".field-app-telemetry-schedule__table tbody tr"
  ).length;
  const scale = rowCount > 30 ? 0.78 : rowCount > 25 ? 0.86 : rowCount > 20 ? 0.92 : 1;

  element.classList.add(TELEMETRY_EXPORT_AREA_CLASS);
  try {
    await savePDF(element, {
      paperSize: "A4",
      landscape: true,
      margin: "8mm",
      fileName: fileName || "telemetria.pdf",
      scale,
    });
  } finally {
    element.classList.remove(TELEMETRY_EXPORT_AREA_CLASS);
  }
}
